import { z } from 'zod';
import { DraftStudyDetailSchema } from './entity';
import { toRequired } from '../utils/schema';
import { COMPUTED_FIELDS } from './publish';

import { UpdateTargetPopulationDtoSchema } from '../target-population/target-population.dto';
import { StudyCategorySchema } from './category';
import { PagingSchema } from '../shared/paging';

export const CreateStudyCategoryDtoSchema = StudyCategorySchema.omit({
  id: true,
  createdAt: true,
});

export const UpdateStudyCategoryDtoSchema = StudyCategorySchema.omit({
  createdAt: true,
});

export const UpdateStudyDtoSchema = DraftStudyDetailSchema.partial()
  .omit(toRequired(COMPUTED_FIELDS))
  .merge(
    z
      .object({
        category: StudyCategorySchema.nullable(),
        targetPopulation: UpdateTargetPopulationDtoSchema,
      })
      .partial(),
  );
export type UpdateStudyDto = z.infer<typeof UpdateStudyDtoSchema>;

export type CreateStudyCategoryDto = z.infer<
  typeof CreateStudyCategoryDtoSchema
>;

export type UpdateStudyCategoryDto = z.infer<
  typeof UpdateStudyCategoryDtoSchema
>;

export const ListStudySchema = PagingSchema.extend({
  name: z.string().optional(),
  contactName: z.string().optional(),
  status: z.enum(['draft', 'published']).optional(),
  categoryId: z.string().uuid().optional(),
});

export type ListStudy = z.infer<typeof ListStudySchema>;
